import navBarData from "../../Routes/navBarData";
import { useLocation } from "react-router-dom";
import { formatDateTime } from "./formatDateTime";
import GoBackButton from "./GoBackButton";
import { RefreshCw } from "lucide-react";
import RefreshButton from "./RefreshButton";

export default function ContentHeader({
  name,
  city,
  joinedOn,
  email,
  mobile,
  loginUserCreated,
  userRole,
}) {
  const location = useLocation();

  let currentNavItem = navBarData.find((item) =>
    location.pathname.startsWith(item.path)
  );

  // 🔥 Dynamic label for empdash
  if (currentNavItem?.id === "empdash") {
    currentNavItem = {
      ...currentNavItem,
      label: userRole === 3 ? "Dashboard" : "Leads",
    };
  }

  const hideBackButton = currentNavItem?.label === "Retailer Onboarding";

  return (
    <header className="bg-white/90 backdrop-blur border-b px-4 sm:px-6 flex justify-between items-center">
      
      {/* LEFT SIDE */}
      <div className="flex items-center gap-3">
        <div className="py-1 border-b border-slate-100">
          {!hideBackButton && (
            <div className="hidden sm:block pb-2">
              <GoBackButton />
            </div>
          )}

          <div className="text-lg font-bold text-slate-800">
            {currentNavItem?.label || ""}
          </div>

         
        </div>
      </div>

      {/* 🔥 MOBILE REFRESH BUTTON */}
      <div className="block sm:hidden">
        <RefreshButton onClick={() => window.location.reload()} />
      </div>

      

      {/* DESKTOP USER INFO */}
      <div className="hidden sm:block text-[12px] text-right">
        <p>
          Email: <span className="font-medium">{email}</span>
        </p>
        <p>
          Mobile: <span className="font-medium">{mobile}</span>
        </p>
        <p>Member since {formatDateTime(loginUserCreated)}</p>

        
      </div>

      

    </header>
  );
}


// import { User } from "lucide-react";
// import navBarData from "../../Routes/navBarData";
// import { useLocation } from "react-router-dom";
// import { formatDateTime } from "./formatDateTime";
// import GoBackButton from "./GoBackButton";

// export default function ContentHeader({ name, city, joinedOn, email, mobile, loginUserCreated, userRole }) {

//   const location = useLocation();

//   // Find current nav item based on path
//   let currentNavItem = navBarData.find((item) =>
//     location.pathname.startsWith(item.path)
//   );

//   // 🔥 Dynamic label for empdash
//   if (currentNavItem?.id === "empdash") {
//     currentNavItem = {
//       ...currentNavItem,
//       label: userRole === 3 ? "Dashboard" : "Leads",
//     };
//   }

//   const hideBackButton = currentNavItem?.label === "Retailer Onboarding";

//   return (
//     <header className="bg-white/90 backdrop-blur border-b px-6 flex justify-between items-center">
//       <div className="flex items-center gap-3">
//         <div className="py-2 border-b border-slate-100">

//           {/* ---- Show Back button ONLY if not onboarding ---- */}
//           {!hideBackButton && (
//             <div className="pb-2">
//               <GoBackButton />
//             </div>
//           )}
//           <div className="text-lg font-bold text-slate-800">
//             {currentNavItem?.label || ""}
//           </div>
//         </div>
//       </div>

//       <div className="text-[12px] text-right">
//         <p>Email: <span className="font-medium">{email}</span></p>
//         <p>Mobile: <span className="font-medium">{mobile}</span></p>
//         <p>Member since {formatDateTime(loginUserCreated)}</p>
//       </div>
//     </header>
//   );
// }



// import { User } from "lucide-react";
// import navBarData from "../../Routes/navBarData";
// import { useLocation } from "react-router-dom";
// import { formatDateTime } from "./formatDateTime";
// import GoBackButton from "./GoBackButton";

// export default function ContentHeader({ name, city, joinedOn, email, mobile, loginUserCreated }) {

//   const location = useLocation();

//   // Find current nav item based on path
//   const currentNavItem = navBarData.find((item) =>
//     location.pathname.startsWith(item.path)
//   );

//   const hideBackButton = currentNavItem?.label === "Retailer Onboarding";

//   return (
//     <header className="bg-white/90 backdrop-blur border-b px-6 flex justify-between items-center">
//       <div className="flex items-center gap-3">
//         <div className="py-2 border-b border-slate-100">

//           {/* ---- Show Back button ONLY if not onboarding ---- */}
//           {!hideBackButton && (
//             <div className="pb-2">
//               <GoBackButton />
//             </div>
//           )}

//           <div className="text-xs font-semibold tracking-wide text-blue-600 uppercase">
//             {currentNavItem?.label || ""}
//           </div>
//           <div className="text-lg font-bold text-slate-800">
//             {currentNavItem?.label || ""}
//           </div>
//         </div>
//       </div>

//       <div className="text-[12px] text-right">
//         <p>Email: <span className="font-medium">{email}</span></p>
//         <p>Mobile: <span className="font-medium">{mobile}</span></p>
//         <p>Member since {formatDateTime(loginUserCreated)}</p>
//       </div>
//     </header>
//   );
// }



// import { User } from "lucide-react";
// import navBarData from "../../Routes/navBarData";
// import { useLocation } from "react-router-dom";
// import { formatDateTime } from "./formatDateTime";
// import GoBackButton from "./GoBackButton";

// export default function ContentHeader({ name, city, joinedOn, email, mobile, loginUserCreated }) {

//     const location = useLocation();
    
//       // Find current nav item based on path
//       const currentNavItem = navBarData.find((item) =>
//         location.pathname.startsWith(item.path)
//       );
    
//   return (
//     <header className="bg-white/90 backdrop-blur border-b px-6 flex justify-between items-center">
//       <div className="flex items-center gap-3">
    
//         <div className="py-2 border-b border-slate-100">
//            <div className="pb-2">
//             <GoBackButton/>
//           </div>
//               <div className="text-xs font-semibold tracking-wide text-blue-600 uppercase">
//                 {currentNavItem?.label || ""}
//               </div>
//               <div className="text-lg font-bold text-slate-800">
//                 {currentNavItem?.label ? `${currentNavItem.label}` : ""}
//               </div>
//             </div>
//       </div>

//       <div className="text-[12px] text-right">
//         <p>Email: <span className="font-medium">{email}</span></p>
//         <p>Mobile: <span className="font-medium">{mobile}</span></p>
//         <p>Member since {formatDateTime(loginUserCreated)}</p>
//       </div>
//     </header>
//   );
// }
